import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { accountActions } from '../store/account/account.state';
import { LoginService } from '../../login/login.service';

@Injectable({ providedIn: 'root' })
export class TravomateLogoutService extends LoginService {
  private store = inject(Store);
  private readonly router = inject(Router);

  logout(): void {
    this.store.dispatch(accountActions.logout());
    this.router.navigate(['/login']);
  }
}
